import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  MeetingUserAvailabilityOverrideRequest,
  MeetingUserAvailabilityOverrideResponse,
  PageResponse,
} from '../models/meeting.model';

@Injectable({ providedIn: 'root' })
export class MeetingAvailabilityOverrideApiService {
  private url = `${environment.apiUrl}api/meeting-availability-overrides`;
  constructor(private http: HttpClient) {}

  list(
    idUser: number,
    businessId: number,
    page = 0,
    size = 20
  ): Observable<PageResponse<MeetingUserAvailabilityOverrideResponse>> {
    const params = new HttpParams()
      .set('idUser', idUser.toString())
      .set('businessId', businessId.toString())
      .set('page', page.toString())
      .set('size', size.toString());
    return this.http.get<PageResponse<MeetingUserAvailabilityOverrideResponse>>(
      this.url,
      { params }
    );
  }

  getById(
    id: number,
    businessId: number
  ): Observable<MeetingUserAvailabilityOverrideResponse> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.get<MeetingUserAvailabilityOverrideResponse>(
      `${this.url}/${id}`,
      { params }
    );
  }

  create(
    body: MeetingUserAvailabilityOverrideRequest
  ): Observable<MeetingUserAvailabilityOverrideResponse> {
    return this.http.post<MeetingUserAvailabilityOverrideResponse>(
      this.url,
      body
    );
  }

  update(
    id: number,
    businessId: number,
    body: MeetingUserAvailabilityOverrideRequest
  ): Observable<MeetingUserAvailabilityOverrideResponse> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.put<MeetingUserAvailabilityOverrideResponse>(
      `${this.url}/${id}`,
      body,
      { params }
    );
  }

  delete(id: number, businessId: number): Observable<void> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.delete<void>(`${this.url}/${id}`, { params });
  }
}
